app.service('router', ['$rootScope', function ($rootScope) {
    this.init = function () {
        $.router.init();
    };

    this.subscribe = function (url, callback) {
        $.route(url, function (data, params, query) {
            let phase = $rootScope.$$phase;
            if (phase == '$apply' || phase == '$digest') {
                callback(data, params, query);
            } else {
                $rootScope.$apply(function () {
                    callback(data, params, query)
                });
            }
        });
    };

    this.navigate = function (url) {
        $.router.set(url);
    };
}]);

app.directive('ngNavigate', ['router', function (router) {
    return {
        restrict: "A",
        scope: {
            isRouterNavigate: "=ngNavigate"
        },
        link: function ($scope, element, attrs) {
            element.on('click', function (e) {
                if ($scope.isRouterNavigate === false) {
                    return true;
                }
                let url = element.attr('href');
                if (url.includes('#')) {
                    e.preventDefault();
                    return false;
                }
                router.navigate(url);
                e.preventDefault();
            });
        }
    };
}]);

app.directive('ngPaginator', [function () {
    return {
        restrict: "A",
        scope: {
            paginator: "=ngPaginator",
            initCount: "@"
        },
        template: '' +
            '<li ng-if="arrows.left" ng-class="{disabled:arrows.left.disabled}"><a href="{{arrows.left.url}}" ng-navigate=""><i class="icon-left"></i></a></li>' +
            '<li ng-repeat="page in pages"  ng-class="{active:page.current}">' +
            '<a ng-if="!page.skip" href="{{page.url}}" ng-navigate="">{{page.index}}</a><span ng-if="page.skip">...</span></li>' +
            '<li ng-if="arrows.right" ng-class="{disabled:arrows.right.disabled}"><a href="{{arrows.right.url}}" ng-navigate=""><i class="icon-right"></i></a></li>',
        link: function ($scope, element, attrs) {
            if ($scope.initCount) {
                $scope.paginator.count = parseInt($scope.initCount);
            }

            $scope.$watch('[paginator.current, paginator.count, paginator.url]', function (value) {
                if (!$scope.paginator.url) {
                    $scope.pages = [];
                    $scope.arrows = {};
                    return;
                }
                $scope.pages = getPages($scope.paginator);
                $scope.arrows = getArrows($scope.pages, $scope.paginator);
            });

            function getUrl(index) {
                let url = $scope.paginator.url;
                return (index > 1) ? (url + (url.indexOf('?') > 0 ? '&p=' : '?p=') + index) : url;
            }

            function getPages(paginator) {
                let pages = [];
                let pagesCount = Math.floor((paginator.count - 1) / paginator.size) + 1;
                for (let i = 1; i <= pagesCount; i++) {
                    if ((i <= paginator.current + 1 & i >= paginator.current - 1) || i === 1 || i === pagesCount) {
                        let page = {index: i, current: i === paginator.current, url: getUrl(i)};
                        pages.push(page);
                    } else if (i === 2 || i === pagesCount - 1) {
                        pages.push({index: i, skip: true});
                    }
                }
                return pages;
            }

            function getArrows(pages, paginator) {
                if (pages.length) {
                    let left = {disabled: pages[0].current, url: '#'};
                    let right = {disabled: pages[pages.length - 1].current, url: '#'};
                    if (!left.disabled) left.url = getUrl(paginator.current - 1);
                    if (!right.disabled) right.url = getUrl(paginator.current + 1);
                    return {
                        left: left,
                        right: right
                    }
                }
                return {}
            }
        }
    };
}]);

app.directive('ngProperties', [function () {
    return {
        restrict: "A",
        templateUrl: 'properties-tpl'
    };
}]);

app.directive('uiMapCatalog', ['$window', '$q', '$filter', '$compile', 'googleMapsLoader', 'geoService', 'propertyService', 'GOOGLE_MAPS_CONFIG', function ($window, $q, $filter, $compile, googleMapsLoader, geoService, propertyService, GOOGLE_MAPS_CONFIG) {
    const COUNTRY_BOUNDS = {south: 5.5, west: 97, north: 20.5, east: 106};
    const DEFAULT_CENTER = {lat: 12.9236, lng: 100.8825};
    const DEFAULT_ZOOM = 11;
    const DISPLAY_KEYS = ['order_by', 'view', 'show_map', 'page', 'offset', 'limit'];

    return {
        restrict: 'A',
        scope: {propertyFilter: '=uiMapCatalog', hoveredMarker: '=?mapHover'},
        templateUrl: 'catalog-map-tpl',
        link: function ($scope, element, attrs) {
            let activated = false;
            let destroyed = false;
            let generation = 0;
            let lastFilterKey = null;
            let lastGeoId;
            let lastProjectId = null;
            let maps = null;
            let MarkerClusterer = null;
            let map = null;
            let clusterer = null;
            let markers = [];
            let selectedMarker = null;
            let hoveredMarker = null;
            let infoWindow = null;
            let popupScope = null;
            let popupElement = null;
            let observer = null;

            $scope.mapState = 'idle';
            $scope.retry = function () {
                requestLatest(true);
            };

            if ($window.IntersectionObserver) {
                observer = new $window.IntersectionObserver(function (entries) {
                    if (entries.some(function (entry) { return entry.isIntersecting; })) {
                        $scope.$evalAsync(activate);
                    }
                }, {rootMargin: '300px 0px'});
                observer.observe(element[0]);
            }

            $scope.$watch(function () {
                return isShown() ? getFilterKey($scope.propertyFilter) : null;
            }, function () {
                if (!observer && isShown()) activate();
                if (!isShown()) closePopup();
                requestLatest();
                updateHoveredMarker();
            });

            $scope.$watch('hoveredMarker', updateHoveredMarker);
            $scope.$watch(function () { return $scope.propertyFilter && $scope.propertyFilter.order_by; }, closePopup);

            $scope.$on('$destroy', function () {
                destroyed = true;
                generation++;
                if (observer) observer.disconnect();
                clearMarkers();
                clearBoundary();
                if (infoWindow) maps.event.clearInstanceListeners(infoWindow);
                if (map) maps.event.clearInstanceListeners(map);
                map = null;
            });

            function isShown() {
                return !!($scope.propertyFilter && $scope.propertyFilter.show_map);
            }

            function activate() {
                if (destroyed || activated) return;
                activated = true;
                if (observer) observer.disconnect();
                requestLatest();
            }

            function requestLatest(force) {
                if (!activated || destroyed || !isShown()) return;
                let key = getFilterKey($scope.propertyFilter);
                if (!force && key === lastFilterKey) return;
                lastFilterKey = key;
                refresh(angular.copy($scope.propertyFilter));
            }

            function refresh(filter) {
                closePopup();
                let requestId = ++generation;
                let geoId = filter.geo_node_id || null;
                let projectId = filter.project_id ? String(filter.project_id) : null;
                let geoChanged = geoId !== lastGeoId;
                let moveCamera = !map || geoChanged || projectId !== lastProjectId;
                $scope.mapState = 'loading';

                $q.all({
                    libraries: settle(googleMapsLoader.load()),
                    clustering: settle(googleMapsLoader.loadClusterer()),
                    context: settle(geoId ? geoService.getMapContext(geoId) : $q.resolve(null)),
                    markers: settle(propertyService.getMapMarkers(filter))
                }).then(function (result) {
                    if (destroyed || requestId !== generation) return;
                    if (!isShown()) {
                        lastFilterKey = null;
                        return;
                    }
                    if (!result.libraries.ok || !result.clustering.ok) {
                        $scope.mapState = 'unavailable';
                        return;
                    }
                    maps = result.libraries.value;
                    MarkerClusterer = result.clustering.value;
                    createMap();

                    let context = result.context.ok ? result.context.value : null;
                    let data = result.markers.ok ? result.markers.value : {markers: [], project: null};
                    if (!projectId) {
                        showGeo(context, data.markers, geoId, moveCamera);
                        lastProjectId = null;
                    } else if (showProject(data, projectId, moveCamera)) {
                        lastProjectId = projectId;
                    } else if (geoChanged) {
                        // The project has no usable position: show the new geography without it.
                        showGeo(context, data.markers, geoId, true);
                        lastProjectId = null;
                    }
                    lastGeoId = geoId;
                    $scope.mapState = !result.markers.ok ? 'marker-error' : data.markers.length ? 'ready' : 'empty';
                }).catch(function () {
                    if (!destroyed && requestId === generation) $scope.mapState = 'unavailable';
                });
            }

            function showGeo(context, rows, geoId, moveCamera) {
                updateBoundary(context);
                updateMarkers(rows, true);
                if (moveCamera) positionCamera(context, rows, geoId);
            }

            function showProject(data, projectId, moveCamera) {
                let project = data.project;
                let marker = data.markers.find(function (row) {
                    return row.kind === 'project' && String(row.id) === projectId;
                }) || (project && {
                    kind: 'project', id: project.id, title: project.title, position: project.position, count: 0, price: null
                });
                if (!marker) return false;
                clearBoundary();
                updateMarkers([marker], false);
                markers[0].classList.add('catalog-map__marker--project');
                if (moveCamera) {
                    map.setCenter(marker.position);
                    map.setZoom(project && project.zoom || 15);
                }
                return true;
            }

            function createMap() {
                if (map) return;
                map = new maps.Map(element[0].querySelector('.catalog-map__canvas'), {
                    center: DEFAULT_CENTER,
                    zoom: DEFAULT_ZOOM,
                    fullscreenControl: false,
                    gestureHandling: 'greedy',
                    mapId: GOOGLE_MAPS_CONFIG.mapId
                });
                map.data.setStyle({
                    strokeColor: '#537690', strokeWeight: 2, strokeOpacity: 1,
                    fillColor: '#537690', fillOpacity: 0.08, clickable: false
                });
                maps.event.addListener(map, 'click', closePopup);
            }

            function updateBoundary(context) {
                clearBoundary();
                if (context && context.boundary) {
                    map.data.addGeoJson({type: 'Feature', properties: {}, geometry: context.boundary.geometry});
                }
            }

            function clearBoundary() {
                if (map) map.data.forEach(function (feature) { map.data.remove(feature); });
            }

            function positionCamera(context, rows, geoId) {
                if (!geoId) {
                    map.fitBounds(COUNTRY_BOUNDS, 64);
                } else if (context && context.boundary) {
                    map.fitBounds(context.boundary.bbox, 32);
                } else if (rows.length > 1) {
                    let bounds = new maps.LatLngBounds();
                    rows.forEach(function (row) { bounds.extend(row.position); });
                    map.fitBounds(bounds, 48);
                } else if (rows.length) {
                    map.setCenter(rows[0].position);
                    map.setZoom(15);
                } else {
                    let center = context && context.center;
                    map.setCenter(center || DEFAULT_CENTER);
                    map.setZoom(center ? center.zoom : DEFAULT_ZOOM);
                }
            }

            function updateMarkers(rows, clustered) {
                clearMarkers();
                markers = rows.map(createMarker);
                if (clustered && markers.length > 1) {
                    clusterer = new MarkerClusterer({
                        map: map,
                        markers: markers,
                        algorithmOptions: {minPoints: 5, radius: 45, maxZoom: 12},
                        renderer: {render: createCluster},
                        onClusterClick: function (event, cluster, map) {
                            map.setCenter(cluster.position);
                            map.setZoom(map.getZoom() + 1);
                        }
                    });
                    maps.event.addListener(clusterer, 'clusteringend', updateHoveredMarker);
                }
                updateHoveredMarker();
            }

            function createMarker(row) {
                let price = row.price == null ? '' : $filter('compactPrice')(row.price);
                if (price && row.kind === 'project' && row.count > 1) price = attrs.fromLabel + ' ' + price;
                let content = createElement('div', 'catalog-map__dot');
                if (price) content.append(createElement('span', 'catalog-map__price', price));
                let marker = new maps.AdvancedMarkerElement({
                    map: map,
                    position: row.position,
                    anchorTop: '-50%',
                    gmpClickable: true,
                    title: [row.title, row.count || '', price].filter(Boolean).join(' · ')
                });
                marker.classList.add('catalog-map__marker');
                marker.mapData = row;
                marker.append(content);
                marker.addEventListener('gmp-click', selectMarker);
                return marker;
            }

            function createCluster(cluster) {
                let count = cluster.markers.reduce(function (total, marker) {
                    return total + marker.mapData.count;
                }, 0);
                let marker = new maps.AdvancedMarkerElement({position: cluster.position, zIndex: 1000 + cluster.count});
                marker.classList.add('catalog-map__marker');
                marker.append(createElement('div', 'catalog-map__cluster', String(count)));
                return marker;
            }

            function createElement(tag, className, text) {
                let node = $window.document.createElement(tag);
                node.className = className;
                if (text) node.textContent = text;
                return node;
            }

            function clearMarkers() {
                closePopup();
                setHovered(null);
                if (clusterer) {
                    maps.event.clearInstanceListeners(clusterer);
                    clusterer.setMap(null);
                    clusterer.clearMarkers(true);
                    clusterer = null;
                }
                markers.forEach(function (marker) {
                    marker.removeEventListener('gmp-click', selectMarker);
                    maps.event.clearInstanceListeners(marker);
                    marker.map = null;
                });
                markers = [];
            }

            function updateHoveredMarker() {
                setHovered(isShown() ? findHoverTarget($scope.hoveredMarker) : null);
            }

            function setHovered(marker) {
                if (hoveredMarker) hoveredMarker.classList.remove('catalog-map__marker--hover');
                hoveredMarker = marker || null;
                if (hoveredMarker) hoveredMarker.classList.add('catalog-map__marker--hover');
            }

            // A hovered card highlights its own dot, or the cluster that currently contains it.
            function findHoverTarget(key) {
                if (!key) return null;
                let marker = markers.find(function (item) {
                    return item.mapData.kind + ':' + item.mapData.id === key;
                });
                if (!marker || !clusterer) return marker;
                let cluster = clusterer.clusters.find(function (item) { return item.markers.includes(marker); });
                return cluster ? cluster.marker : marker;
            }

            function selectMarker(event) {
                let marker = event.currentTarget;
                if (selectedMarker === marker) return;
                if (selectedMarker) selectedMarker.classList.remove('catalog-map__marker--active');
                selectedMarker = marker;
                marker.classList.add('catalog-map__marker--active');
                $scope.$evalAsync(function () {
                    if (!destroyed && selectedMarker === marker) openPopup(marker);
                });
            }

            function openPopup(marker) {
                if (!infoWindow) {
                    infoWindow = new maps.InfoWindow({maxWidth: 440});
                    maps.event.addListener(infoWindow, 'close', function () {
                        // open() closes the previous anchor first, so only a window that stayed closed counts.
                        $scope.$evalAsync(function () {
                            if (!infoWindow.isOpen) closePopup();
                        });
                    });
                }
                // uiMapPopup adds its class only once the server template has linked, so a missing
                // class means the template request failed: compile again to request it anew.
                if (!popupElement || !popupElement.hasClass('catalog-map-popup')) {
                    if (popupScope) popupScope.$destroy();
                    popupScope = $scope.$new();
                    popupElement = $compile('<div data-ui-map-popup="popup"></div>')(popupScope);
                    infoWindow.setContent(popupElement[0]);
                }
                popupScope.popup = {marker: marker.mapData, filter: angular.copy($scope.propertyFilter)};
                infoWindow.setHeaderContent(createElement('div', 'catalog-map-popup__title', marker.mapData.title));
                infoWindow.setOptions({ariaLabel: marker.mapData.title});
                infoWindow.open({map: map, anchor: marker, shouldFocus: false});
            }

            function closePopup() {
                if (!selectedMarker) return;
                selectedMarker.classList.remove('catalog-map__marker--active');
                selectedMarker = null;
                if (popupScope) popupScope.popup = null;
                if (infoWindow) infoWindow.close();
            }

            function settle(promise) {
                return promise.then(function (value) { return {ok: true, value: value}; },
                    function () { return {ok: false}; });
            }

            function getFilterKey(filter) {
                let result = {};
                Object.keys(filter).sort().forEach(function (key) {
                    let value = filter[key];
                    if (DISPLAY_KEYS.indexOf(key) !== -1 || value == null || value === '') return;
                    if (Array.isArray(value)) {
                        if (value.every(function (item) { return item == null; })) return;
                        value = value.slice();
                        if (key === 'facilities' || key === 'geo_node_ids') value.sort();
                    }
                    result[key] = value;
                });
                return JSON.stringify(result);
            }
        }
    };
}]);

app.directive('uiMapPopup', ['propertyService', 'LANG', function (propertyService, LANG) {
    return {
        restrict: 'A',
        scope: {popup: '=uiMapPopup'},
        templateUrl: LANG.path + '/block/catalog-map-popup/',
        link: function ($scope, element) {
            const list = element[0].querySelector('.catalog-map-popup__items');
            let destroyed = false;
            let filter = null;
            let offset = 0;
            let limit = 5;
            let hasMore = false;

            element.addClass('catalog-map-popup');
            list.addEventListener('scroll', onScroll, {passive: true});
            $scope.loadMore = loadMore;

            $scope.$watch('popup', function (popup) {
                $scope.properties = [];
                $scope.count = null;
                $scope.loading = false;
                $scope.error = false;
                offset = 0;
                hasMore = !!popup;
                list.scrollTop = 0;
                if (!popup) return;
                filter = angular.copy(popup.filter);
                filter[popup.marker.kind === 'project' ? 'project_id' : 'id'] = popup.marker.id;
                limit = popup.marker.kind === 'project' ? 5 : 1;
                $scope.isSale = !!filter.is_sale || !filter.is_rent;
                loadMore();
            });

            $scope.$on('$destroy', function () {
                destroyed = true;
                list.removeEventListener('scroll', onScroll);
            });

            function loadMore() {
                if (destroyed || !$scope.popup || $scope.loading || !hasMore) return;
                const popup = $scope.popup;
                $scope.loading = true;
                $scope.error = false;
                propertyService.getProperties(filter, offset, limit, false, false).then(function (data) {
                    if (destroyed || popup !== $scope.popup) return;
                    const ids = new Set($scope.properties.map(function (item) { return item.id; }));
                    data.properties.forEach(function (item) {
                        if (!ids.has(item.id)) {
                            $scope.properties.push(item);
                            ids.add(item.id);
                        }
                    });
                    offset += data.properties.length;
                    $scope.count = data.count;
                    hasMore = data.properties.length > 0 && offset < data.count;
                }, function () {
                    if (!destroyed && popup === $scope.popup) $scope.error = true;
                }).finally(function () {
                    if (!destroyed && popup === $scope.popup) $scope.loading = false;
                });
            }

            function onScroll() {
                if (!$scope.error && list.scrollHeight - list.clientHeight - list.scrollTop < 80) {
                    $scope.$evalAsync(loadMore);
                }
            }
        }
    };
}]);

app.controller('catalogController', ['$rootScope', '$scope', '$controller', '$timeout', '$cookies', '$document', 'router', 'propertyService', 'geoService', 'catalogFilterService', 'currencyService', 'TRANS', 'FILTER_DATA', function ($rootScope, $scope, $controller, $timeout, $cookies, $document, router, propertyService, geoService, catalogFilterService, currencyService, TRANS, FILTER_DATA) {
    //controller inheritance from appController
    $controller('appController', {$scope: $scope});

    $scope.FILTER_DATA = FILTER_DATA;

    $scope.filter = null;
    $scope.isFilterUpdated = false;
    $scope.isFilterActive = false;

    $scope.properties = null;
    $scope.propertiesCount = 0;
    $scope.mapHover = {key: null};

    $scope.catalogNavigation = FILTER_DATA.CATALOG_NAVIGATION;

    $scope.isInitialState = true;
    $scope.displayPropertiesHtml = true;
    $scope.displayCatalogNavigationHtml = true;
    $scope.displayCatalogPageHtml = true;

    let catalogNavigationRequestId = 0;

    $scope.paginator = {
        count: 0,
        current: 1,
        size: 12,
        url: null,
    };

    $rootScope.page = {};

    $scope.marketFilter = {
        type_id: null
    };

    $scope.loadMarket = function () {
        if (!$scope.filter) return;

        const propertyFilter = angular.copy($scope.filter);
        propertyFilter.type_id = $scope.marketFilter.type_id;

        return propertyService.getPage(propertyFilter).then(function (data) {
            const page = $rootScope.page;

            page.snapshot = data.snapshot;
            page.content = page.content || {};
            page.content.market = data.content.market || {};
        }, angular.noop);
    };


    // Layout options (card view, map) change the width available to carousels, so they trigger a resize.
    $scope.filterSetLayout = function (name, value) {
        $scope.filter[name] = value;
        $scope.filterChanged();
        $timeout(function () {
            window.dispatchEvent(new Event("resize"));
        }, 5);
    };

    $scope.openFilter = function () {
        $scope.isFilterActive = true;
    };

    $scope.closeFilter = function () {
        $scope.isFilterActive = false;
    };

    $scope.toggleFilter = function () {
        $scope.isFilterActive = !$scope.isFilterActive;
    };

    $scope.filterSelectAction = function (is_sale, is_rent) {
        if ($scope.filter.is_sale === is_sale && $scope.filter.is_rent === is_rent) return;
        $scope.filter.is_sale = is_sale;
        $scope.filter.is_rent = is_rent;
        $scope.filter.rent_price = [null, null];
        $scope.filter.sale_price = [null, null];
        $scope.filterChanged();
    };

    $scope.filterSearchAction = function (item) {
        if (!item) return;
        $scope.filter.geo_node_id = item.geo_node ? item.geo_node.id : null;
        $scope.filter.project_id = item.project_id ? item.project_id : null;
        $scope.filter.type_id = item.type_id ? item.type_id : $scope.filter.type_id;
        if (item.geo_node) geoService.addCacheGeo(item.geo_node);
        $scope.filterChanged();
    };

    $scope.filterSalePriceChanged = function () {
        let filter = $scope.filter;
        if (filter.sale_price[0] && filter.sale_price[1] && filter.sale_price[1] < filter.sale_price[0]) {
            filter.sale_price[1] = filter.sale_price[0];
        }
        filter.rent_price = [null, null];
        $scope.filterChanged();
    };

    $scope.filterRentPriceChanged = function () {
        let filter = $scope.filter;
        if (filter.rent_price[1] && filter.rent_price[0] && filter.rent_price[1] < filter.rent_price[0]) {
            filter.rent_price[1] = filter.rent_price[0];
        }
        filter.sale_price = [null, null];
        $scope.filterChanged();
    };

    $scope.filterAreaChanged = function () {
        let filter = $scope.filter;
        if (filter.area[0] && filter.area[1] && filter.area[1] < filter.area[0]) {
            filter.area[1] = filter.area[0];
        }
        $scope.filterChanged();
    };

    $scope.clearFilter = function (type) {
        let filter = $scope.filter;
        if (type && type !== 'beds' && type !== 'price' && type !== 'more') return;

        if (!type || type === 'beds') {
            filter.beds = null;
        }
        if (!type || type === 'price') {
            filter.sale_price = [null, null];
            filter.rent_price = [null, null];
        }
        if (!type || type === 'more') {
            filter.area = [null, null];
            filter.ownership_id = null;
            filter.view_id = null;
            filter.furnishing_id = null;
            filter.facilities = [];
        }
        $scope.filterChanged();
    };

    $scope.filterChanged = function () {
        $scope.isFilterUpdated = true;
        let url = catalogFilterService.filterToUrl($scope.filter);
        router.navigate(url);
    };

    $scope.updateFilter = function (data, query) {
        return catalogFilterService.routeDataToFilter(data, query).then(function (filter) {
            $scope.filter = filter;
            return filter;
        });
    };

    $scope.loadProperties = function (append) {
        if (append) $scope.paginator.current += 1;
        let limit = $scope.paginator.size;
        let offset = ($scope.paginator.current - 1) * limit;
        propertyService.getProperties($scope.filter, offset, limit, true).then(function (data) {
            // if append and $scope.properties - coz properties can be null append on html
            $scope.markBookmarks(data.properties);
            let properties = append && $scope.properties ? $scope.properties.concat(data.properties) : data.properties;
            $scope.properties = properties;
            $scope.paginator.count = data.count;
            $rootScope.page = data.page || {};
            $scope.marketFilter.type_id = $scope.filter.type_id;
            $scope.displayCatalogPageHtml = false;

            if ($scope.filter.project_id) {
                $scope.catalogNavigation = null;
                $scope.displayCatalogNavigationHtml = false;
            }

            //hide html properties after properties loaded
            if ($scope.displayPropertiesHtml && !append) $scope.displayPropertiesHtml = false;
            if (!append) {
                $scope.mapHover.key = null;
                $document.scrollTop(0, 500);
            }
        })
    };

    $scope.hoverProperty = function (propertyId, projectId) {
        $scope.mapHover.key = projectId
            ? 'project:' + projectId
            : 'property:' + propertyId;
    };

    $scope.catalogDistributionWidth = function (item) {
        let snapshot = $rootScope.page && $rootScope.page.snapshot;
        let total = snapshot ? snapshot.sample_count : 0;
        return total ? Math.min(item.count / total * 100, 100) : 0;
    };

    function getParentGeoPath(path) {
        if (!path) return null;

        let parts = path.split('/').filter(function (part) {
            return part;
        });
        parts.pop();
        return parts.length ? parts.join('/') : null;
    }

    function buildCatalogNavigationItem(filter, kind, item) {
        let result = angular.copy(item);
        if (kind === 'geo') {
            geoService.addCacheGeo(result);
            result.url = catalogFilterService.filterToUrlForGeoPath(
                filter,
                result.path
            );
        } else {
            let projectFilter = angular.copy(filter);
            projectFilter.project_id = result.id;
            result.url = catalogFilterService.filterToUrl(projectFilter);
        }
        return result;
    }

    function buildCatalogNavigation(filter, data) {
        let currentGeo = filter.geo_node_id
            ? geoService.findGeoById(filter.geo_node_id)
            : null;
        let backUrl = currentGeo
            ? catalogFilterService.filterToUrlForGeoPath(
                filter,
                getParentGeoPath(currentGeo.path)
            )
            : null;
        let navigation = angular.copy(data);
        navigation.backUrl = backUrl;
        navigation.items = (data.items || []).map(function (item) {
            return buildCatalogNavigationItem(filter, data.kind, item);
        });
        navigation.offset = navigation.items.length;
        return navigation;
    }

    $scope.loadCatalogNavigation = function () {
        let requestId = ++catalogNavigationRequestId;
        let filter = angular.copy($scope.filter);
        if (filter.project_id) {
            return false;
        }

        return propertyService.getCatalogNavigation(filter, 0, 10).then(function (data) {
            if (requestId !== catalogNavigationRequestId) return;

            $scope.catalogNavigation = buildCatalogNavigation(filter, data);
            $scope.displayCatalogNavigationHtml = false;
        }, function () {
        });
    };

    $scope.loadMoreCatalogNavigation = function () {
        let navigation = $scope.catalogNavigation;
        if (navigation.offset >= navigation.count) return false;

        let requestId = catalogNavigationRequestId;
        let requestedOffset = navigation.offset;
        let filter = angular.copy($scope.filter);
        return propertyService.getCatalogNavigation(
            filter,
            requestedOffset,
            10
        ).then(function (data) {
            if (
                requestId !== catalogNavigationRequestId ||
                $scope.catalogNavigation !== navigation ||
                !data ||
                data.kind !== navigation.kind
            ) {
                return false;
            }

            let existingIds = Object.create(null);
            navigation.items.forEach(function (item) {
                existingIds[item.id] = true;
            });
            let appended = [];
            data.items.forEach(function (item) {
                if (existingIds[item.id]) return;
                existingIds[item.id] = true;
                appended.push(buildCatalogNavigationItem(
                    filter,
                    navigation.kind,
                    item
                ));
            });
            navigation.items = navigation.items.concat(appended);
            navigation.offset += data.items.length;
            navigation.count = data.count;
            return navigation.offset < navigation.count;
        });
    };

    $scope.navigate = function (url) {
        if (url) {
            router.navigate(url)
        }
    };

    $scope.updateFilterPresentation = function (filter) {
        let price = filter.is_sale ? filter.sale_price : filter.rent_price;
        let area = filter.area;
        $scope.pins = {
            isFilterBeds: filter.beds !== null,
            isFilterPrice: price && (price[0] || price[1]),
            isFilterMore: area && (area[0] || area[1]) || filter.ownership_id ||
                filter.view_id || filter.furnishing_id || filter.facilities.length > 0
        };

        $scope.filterLabels = {
            beds: $scope.getBedsFilterLabel(filter.beds, FILTER_DATA.BEDS),
            price: $scope.getPriceFilterLabel(price)
        };
    };

    $scope.getBedsFilterLabel = function (beds, options) {
        if (beds == null) return TRANS.BEDS_LABEL;

        options = options || [];
        for (let i = 0; i < options.length; i++) {
            if (String(options[i].id) === String(beds)) {
                return options[i].value;
            }
        }
        return TRANS.BEDS_LABEL;
    };

    $scope.getPriceFilterLabel = function (price) {
        if (!price) return TRANS.PRICE;

        let minPrice = price[0];
        let maxPrice = price[1];
        if (minPrice && maxPrice) {
            return currencyService.formatCompactRange(minPrice, maxPrice);
        }
        if (minPrice) {
            return TRANS.FROM + ' ' + currencyService.formatCompact(minPrice);
        }
        if (maxPrice) {
            return TRANS.UNDER + ' ' + currencyService.formatCompact(maxPrice);
        }
        return TRANS.PRICE;
    };

    function applyRoute(query) {
        if (!$scope.filter) return;

        $scope.marketFilter.type_id = $scope.filter.type_id;

        // update paginator before update properties
        $scope.paginator.url = catalogFilterService.filterToUrl($scope.filter);
        $scope.paginator.current = query['p'] ? parseInt(query['p']) : 1;

        // on first loading use backend rendered properties
        if (!$scope.isInitialState) {
            $scope.loadProperties();
            $scope.loadCatalogNavigation();
        } else {
            $scope.isInitialState = false;
        }

        $scope.isFilterUpdated = false;

        $scope.updateFilterPresentation($scope.filter);
    }

    router.subscribe("/:action_type/", function (data, params, query) {
        if ($scope.isFilterUpdated) {
            applyRoute(query);
            return;
        }
        $scope.updateFilter(data, query).then(function () {
            applyRoute(query);
        });
    });

    router.init();
}]);
